module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSelection),
      expression: "currentSelection"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.selectId,
      "aria-label": _vm.labelText
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentSelection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.quarters), function(quarter) {
    return _c('option', {
      key: quarter.value,
      domProps: {
        "value": quarter.value
      }
    }, [_vm._v("\n        " + _vm._s(quarter.name) + "\n      ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65da22b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comparison/QuarterSelect.vue
// module id = 546
// module chunks = 1